import Queue from "nq-js";

class GetCurrentUserUseCase {
  execute() {
    return new Queue.User().getCurrentUser();
  }
}

export default GetCurrentUserUseCase;
